import ColContainer from './ColContainer';

export default ColContainer;
